import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { site_url } from "./../config.js";
import axios from 'axios';
import { Link } from 'react-router-dom';

function PaymentLedger() {
  const { user } = useContext(AuthContext);
  const [ledgerData, setLedgerData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [shopId, setShopId] = useState('');
  const [shops, setShops] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState('all');

  // Fetch all shops with routes
  const fetchAllShops = async () => {
    try {
      const response = await axios.get(`${site_url}/shoplist_route`);
      if (response.data.status === 'success') {
        const shops = response.data.shops || [];
        setShops(shops);
        
        // Extract unique routes from shops using Map for proper deduplication
        const routeMap = new Map();
        shops.forEach(shop => {
          if (shop.shop_cate && shop.route_name) {
            routeMap.set(shop.shop_cate, {
              id: shop.shop_cate,
              name: shop.route_name
            });
          }
        });
        
        const uniqueRoutes = Array.from(routeMap.values());
        setRoutes(uniqueRoutes);
        
        console.log('Routes loaded:', uniqueRoutes);
      }
    } catch (error) {
      console.error("Error fetching shops", error);
      setShops([]);
      setRoutes([]);
    }
  };
  // Filter shops based on selected route
  const getFilteredShops = () => {
    if (selectedRoute === 'all') {
      return shops;
    }
    return shops.filter(shop => shop.shop_cate == selectedRoute);
  };

  // Fetch ledger data
  const fetchLedgerData = async (selectedShopId) => {
    if (!selectedShopId) return;
    
    setLoading(true);
    try {
      const response = await axios.get(`${site_url}/payment-ledger/${selectedShopId}`);
      if (response.data.status === 'success') {
        setLedgerData(response.data);
      }
    } catch (error) {
      console.error("Error fetching ledger data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllShops();
  }, []);

  const handleRouteChange = (e) => {
    const routeId = e.target.value;
    setSelectedRoute(routeId);
    setShopId(''); // Reset shop selection when route changes
    setLedgerData(null); // Clear ledger data
  };

  const handleShopChange = (e) => {
    const selectedShopId = e.target.value;
    setShopId(selectedShopId);
    if (selectedShopId) {
      fetchLedgerData(selectedShopId);
    } else {
      setLedgerData(null);
    }
  };

  const formatINR = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(amount);
  };


  return (
    <div id="appCapsule">
      <div className="section mt-4">
        <div className="section-heading">
          <h2 className="title">Payment Ledger</h2>
        </div>

        {/* Route Selection */}
        <div className="form-group mb-3">
          <label className="form-label">Route</label>
          <select 
            value={selectedRoute}
            onChange={handleRouteChange}
            className="form-control"
          >
            <option value="all">All Routes</option>
            {routes.map((route) => (
              <option key={route.id} value={route.id}>
                {route.name}
              </option>
            ))}
          </select>
        </div>

        {/* Shop Selection */}
        <div className="form-group mb-3">
          <label className="form-label">Select Shop</label>
          <select 
            value={shopId}
            onChange={handleShopChange}
            className="form-control"
          >
            <option value="">Select a shop</option>
            {getFilteredShops().map((shop) => (
              <option key={shop.shop_id} value={shop.shop_id}>
                {shop.shop_name} - {shop.shop_name_tamil}
              </option>
            ))}
          </select>
        </div>



        {/* Loading State */}
        {loading && (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}

        {/* Ledger Data */}
        {ledgerData && !loading && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">
                Ledger Report
                {ledgerData.runningBalance && (
                  <span className="float-right text-danger">
                    Balance: {formatINR(ledgerData.runningBalance)}
                  </span>
                )}
              </h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-striped table-bordered mb-0">
                  <thead className="thead-dark">
                    <tr>
                      <th>SL No</th>
                      <th>Date</th>
                      <th>Bill No</th>
                      <th>Description</th>
                      <th className="text-center">Debit</th>
                      <th className="text-center">Credit</th>
                      <th className="text-center">Balance</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody dangerouslySetInnerHTML={{ __html: ledgerData.html }} />
                </table>
              </div>
            </div>
          </div>
        )}

        {/* No Data Message */}
        {!ledgerData && !loading && shopId && (
          <div className="alert alert-info">
            No ledger data found for the selected shop.
          </div>
        )}

        {/* No Shop Selected Message */}
        {!shopId && !loading && (
          <div className="alert alert-warning">
            Please select a shop to view the payment ledger.
          </div>
        )}
      </div>

      <Sidebar />
      <Footer />
    </div>
  );
}

export default PaymentLedger;
